import { getExaminerProfileThunk } from '../../../../store/workspace/thunks';
import { setExaminerProfileModal } from '../../../../store/workspace/slice';
import { useDispatch } from '../../../../store/store';
import { useCallback } from 'react';

/**
 * Opens the applicant profile modal and kicks off the fetch of its content.
 * Every table exposes the same "info" action.
 */
export function useExaminerProfile(jobId: string | undefined) {
    const dispatch = useDispatch();

    return useCallback((examinerId: string) => {
        dispatch(getExaminerProfileThunk({ id: examinerId, jobId }));
        dispatch(setExaminerProfileModal(true));
    }, [dispatch, jobId]);
};
